export default {
  name: "mCareIntegrationContactsProfiles",
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null,
    isAnyStaffAssignedToFacility: false,
  },
  computed: {
    isFacilityHasCareAPI() {
      return this.$store.state.facilityModule.isFacilityHasCareAPI;
    },
    contactsCategory: {
      get() {
        return (
          (this.facility.featureMCareContactsProfiles ?? true) &&
          (this.facility.isEnabledStaffAPI ?? true) &&
          (this.facility.isEnabledContactsAPI ?? true) &&
          (this.isFacilityHasCareAPI ? (this.facility.isEnableADT ?? true) : true)
        );
      }
    },
  },
  methods: {
    onIsEnableADTChange(value) {
      if(value === true){
        this.facility.featureNonMCareCustomers = false;
        this.facility.isEnableCSVImportForResidents = false;
        this.facility.isEnableManuallyAddDeleteResidents = false;
      }
    },
    contactsCategoryUpdate(value) {
      this.facility.featureMCareContactsProfiles = value;
      this.facility.isEnabledStaffAPI = value;
      this.facility.isEnabledContactsAPI = value;

      if(this.isFacilityHasCareAPI) {
        this.facility.isEnableADT = value;
      }
    },
  }
}